<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';
import ModalPayCheckbookFastComponent from '@/components/pays/ModalPayCheckbookFastComponent.vue';
import ModalFormCancelFolioComponent from './ModalFormCancelFolioComponent.vue';
import ModalFormCheckFormComponent from '../checks/ModalFormComponent.vue';
import ModalFormCheckbookComponent from '@/components/checks/ModalFormCheckbookComponent.vue'; 

export default {
    props: ['prop_edit'],
    components: {
        ModalPayCheckbookFastComponent,
        ModalFormCancelFolioComponent,
        ModalFormCheckFormComponent,
        ModalFormCheckbookComponent
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            load: false,
            checkbook: {},
            listFolios: [],
            edit_cancel: false,
        }
    },
    methods: {
        generatePay(folio, checkbook) {
            // console.log(folio);
            // console.log(checkbook);
            Event.$emit('event-show-addChecksBook', folio, checkbook);

        },
        showCheck(check) {
            Event.$emit('event-show-addChecks', check);
        },
        showCancel(cancel) {
            this.edit_cancel = false;
            Event.$emit('event-show-showFoliosCheckbooksCancel', cancel);
        },
        cancelFolio(folio) {
            this.edit_cancel = true;
            let checkbook_id = this.checkbook.id;
            Event.$emit('event-show-addCheckbookCancel', checkbook_id, folio);
        },
        showPay(pay) {
            let checkbook = this.checkbook;
            Event.$emit('event-show-showPayCheckbookFast', pay, checkbook);
        },
        closedModal() {
            this.load = false;
            this.checkbook = {};
            this.$modal.hide('showFoliosCheckbooks');
        },
        async list() {
            this.load = true;

            let _endpoint = '/checkbook/folios?checkbook_id=' + this.checkbook.id;

            try {
                let { data } = await request.get(_endpoint)
                if (data) {
                    this.listFolios = data;
                    this.load = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                    this.load = false;
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {

    },
    created() {
        Event.$on("event-show-showFoliosCheckbooks", async (checkbook) => {
            this.checkbook = checkbook;
            await this.list();
            this.$modal.show('showFoliosCheckbooks');
        });
        Event.$on("event-load-FoliosCheckbooks", async () => {
            await this.list();
        });
    }
}
</script>

<template>
    <modal v-bind:click-to-close="false" name="showFoliosCheckbooks" :width="'50%'" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Folios de ({{ checkbook.name }})</h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table table-bordered text-center text-sm">
                            <thead>
                                <tr>
                                    <th>Id cheque</th>
                                    <th>Pago a</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-if="load">
                                <tr>
                                    <td colspan="6" class="text-center">
                                        <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                        <h5>Cargando</h5>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else-if="listFolios.length > 0">
                                <tr v-for="(folioData, index) in listFolios" :key="index"
                                    :class="folioData.cancel ? 'bg-danger' : ''">
                                    <td>
                                        {{ folioData.folio }}<br>
                                        <span v-if="folioData.previous && !folioData.cancel" class="badge badge-info">
                                            Apartado
                                        </span>
                                        <span v-if="folioData.pay.length > 0 && !folioData.cancel" class="badge badge-success">
                                            Pagado
                                        </span>
                                    </td>                                 
                                    <td class="text-left">
                                        <!-- Pago -->
                                        <div v-if="folioData.pay">
                                            <span v-for="(pay, index) in folioData.pay" :key="index">
                                                <hr v-if="index != 0">
                                                <strong>Pago: </strong>
                                                {{ pay.id }}<br>                                      
                                                <span v-if="pay.check_pay">
                                                    <strong>Usuario: </strong>
                                                    {{ pay.check_pay.user.name }} {{ pay.check_pay.user.last_name }}
                                                </span><br>
                                                <strong>Fecha: </strong>    
                                                {{ pay.created_at | toDateTime }}
                                            </span>
                                        </div>
                                        <!-- Cancelación -->
                                        <div v-if="folioData.cancel">
                                            <span v-if="folioData.cancel.user">
                                                <strong>Usuario: </strong>
                                                {{ folioData.cancel.user.name }} {{ folioData.cancel.user.last_name }}
                                            </span><br>
                                            <strong>Fecha: </strong>
                                            {{ folioData.cancel.created_at | toDateTime }}
                                        </div>

                                        <!-- Preview -->
                                        <div v-if="folioData.previous">
                                            <span v-if="folioData.previous.user">
                                                <strong>Usuario: </strong>
                                                {{ folioData.previous.user.name }} {{ folioData.previous.user.last_name }}
                                            </span><br>
                                            <strong>Fecha: </strong>
                                            {{ folioData.previous.created_at | toDateTime }}
                                        </div>
                                    </td>                                
                                    <td class="text-center">
                                        <!-- Pago -->
                                        <div v-show="folioData.pay && !folioData.cancel" class=" m-1"
                                            v-for="(pay, index) in folioData.pay" :key="index">
                                            <hr v-if="index != 0">
                                            <button type="button" class="btn btn-outline-success btn-sm m-1"
                                                @click="showPay(pay)">
                                                <i class="fa fa-eye"></i> Ver pago
                                            </button>
                                            <br>
                                            <button type="button" class="btn btn-outline-info btn-sm m-1"
                                                @click="showCheck(pay.check_pay)">
                                                <i class="fa fa-eye"></i> Ver cheque
                                            </button>
                                        </div>
                                        <!-- Preview -->
                                        <div v-if="folioData.previous && !folioData.cancel" class="d-inline">
                                            <button v-if="folioData.previous" type="button"
                                                class="btn btn-outline-info btn-sm"
                                                @click="showCheck(folioData.previous)">
                                                <i class="fa fa-eye"></i> Ver cheque
                                            </button>
                                        </div>
                                        <!-- Cancelación -->
                                        <div v-if="folioData.cancel" class="">
                                            <span v-if="folioData.cancel" class="badge badge-warning">
                                                <span v-if="folioData.cancel.user">
                                                    {{ folioData.cancel.user.name }} {{ folioData.cancel.user.last_name}}
                                                </span>
                                                <span v-else>Sin usuario</span>
                                            </span>
                                            <br>
                                            <button class="btn btn-secondary btn-sm mt-1"
                                                @click="showCancel(folioData.cancel)">
                                                <i class="fa fa-eye"></i> Ver detalle
                                            </button>
                                        </div>
                                        <!-- Cancelar -->
                                        <div v-if="!folioData.previous && folioData.pay.length == 0" class="d-inline">
                                            <button type="button"
                                                class="btn btn-outline-danger btn-sm m-1" @click="cancelFolio(folioData.folio)">
                                                <i class="fa fa-trash"></i> Cancelar
                                            </button>
                                            <!-- <button type="button" class="btn btn-outline-success btn-sm m-1"
                                                @click="generatePay(folioData, checkbook)">
                                                <i class="fa fa-file-invoice"></i> Generar pago
                                            </button> -->
                                        </div>
                                        
                                    </td>

                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td align="center" colspan="6">Sin resultados.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class="col-md-12">
                    <hr>
                    <button :disabled="load" type="submit" class="btn float-right btn-outline-success" v-if="prop_edit">
                        <span v-if="load">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                        </span>
                        <span v-else>
                            <i class="fas fa-save"></i> Guardar
                        </span>
                    </button>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>
            </div>
            <ModalPayCheckbookFastComponent :prop_edit="prop_edit" />
            <ModalFormCancelFolioComponent :prop_edit="edit_cancel" />
            <ModalFormCheckFormComponent :prop_edit="false" />
            <ModalFormCheckbookComponent :prop_edit="true" />
        </div>
    </modal>
</template>